import queryString from "query-string";
import { CONFIG } from "../config/app.config";
import { EEnvironment } from "../config/app.config.types";
import { ELocale } from "../types/i18n.types";
import { getLocale } from "./i18n/i18n.utils";
import { removeUndefinedValuesFromObject } from "./object.utils";
export var appendQueryParams = function (params) {
    var path = params.path, queryParams = params.queryParams;
    var queryParamsParsed = removeUndefinedValuesFromObject(queryParams);
    var result = queryString.parseUrl(path);
    Object.keys(queryParamsParsed).forEach(function (queryParamKey) {
        var value = queryParamsParsed[queryParamKey];
        if (value !== undefined) {
            result.query[queryParamKey] = "".concat(queryParamsParsed[queryParamKey]);
        }
    });
    return queryString.stringifyUrl(result);
};
export var removeQueryParams = function (params) {
    var path = params.path, keysToRemove = params.keysToRemove;
    var parsed = queryString.parseUrl(path);
    if (parsed === null || parsed === void 0 ? void 0 : parsed.query) {
        keysToRemove.forEach(function (key) {
            delete parsed.query[key];
        });
    }
    return queryString.stringifyUrl(parsed);
};
export var getDashboardUrl = function (params) {
    var _a = params.path, path = _a === void 0 ? "" : _a, queryParams = params.queryParams;
    var domain = "rentio.be";
    switch (CONFIG.ENVIRONMENT) {
        case EEnvironment.Dev:
        case EEnvironment.Stag:
        case EEnvironment.Demo:
            domain = "rentio-internal.be";
            break;
        case EEnvironment.Prod:
        default:
            break;
    }
    var environmentSubdomain = "";
    switch (CONFIG.ENVIRONMENT) {
        case EEnvironment.Dev:
            environmentSubdomain = ".dev";
            break;
        case EEnvironment.Stag:
            environmentSubdomain = ".stag";
            break;
        case EEnvironment.Demo:
            environmentSubdomain = ".demo";
            break;
        case EEnvironment.Prod:
        default:
            break;
    }
    return appendQueryParams({
        path: "https://dashboard".concat(environmentSubdomain, ".").concat(domain, "/").concat(path),
        queryParams: queryParams || {},
    });
};
export var getBackofficeUrl = function (params) {
    var _a = params.path, path = _a === void 0 ? "" : _a, queryParams = params.queryParams;
    var domain = "rentio.be";
    switch (CONFIG.ENVIRONMENT) {
        case EEnvironment.Dev:
        case EEnvironment.Stag:
        case EEnvironment.Demo:
            domain = "rentio-internal.be";
            break;
        case EEnvironment.Prod:
        default:
            break;
    }
    var environmentSubdomain = "";
    switch (CONFIG.ENVIRONMENT) {
        case EEnvironment.Dev:
            environmentSubdomain = ".dev";
            break;
        case EEnvironment.Stag:
            environmentSubdomain = ".stag";
            break;
        case EEnvironment.Demo:
            environmentSubdomain = ".demo";
            break;
        case EEnvironment.Prod:
        default:
            break;
    }
    return appendQueryParams({
        path: "https://backoffice".concat(environmentSubdomain, ".").concat(domain, "/").concat(path),
        queryParams: queryParams || {},
    });
};
export var getRentioPayUrl = function (params) {
    var _a = params.path, path = _a === void 0 ? "" : _a, queryParams = params.queryParams;
    var domain = "rentio.be";
    switch (CONFIG.ENVIRONMENT) {
        case EEnvironment.Dev:
        case EEnvironment.Stag:
        case EEnvironment.Demo:
            domain = "rentio-internal.be";
            break;
        case EEnvironment.Prod:
        default:
            break;
    }
    var environmentSubdomain = "";
    switch (CONFIG.ENVIRONMENT) {
        case EEnvironment.Dev:
            environmentSubdomain = ".dev";
            break;
        case EEnvironment.Stag:
            environmentSubdomain = ".stag";
            break;
        case EEnvironment.Demo:
            environmentSubdomain = ".demo";
            break;
        default:
            break;
    }
    return appendQueryParams({
        path: "https://pay".concat(environmentSubdomain, ".").concat(domain, "/").concat(path),
        queryParams: queryParams || {},
    });
};
export var getMoveUrl = function (params) {
    var _a = params.path, path = _a === void 0 ? "" : _a, queryParams = params.queryParams;
    var domain = "rentio.be";
    switch (CONFIG.ENVIRONMENT) {
        case EEnvironment.Dev:
        case EEnvironment.Stag:
        case EEnvironment.Demo:
            domain = "rentio-internal.be";
            break;
        case EEnvironment.Prod:
        default:
            break;
    }
    var environmentSubdomain = "";
    switch (CONFIG.ENVIRONMENT) {
        case EEnvironment.Dev:
            environmentSubdomain = ".dev";
            break;
        case EEnvironment.Stag:
            environmentSubdomain = ".stag";
            break;
        case EEnvironment.Demo:
            environmentSubdomain = ".demo";
            break;
        case EEnvironment.Prod:
        default:
            break;
    }
    return appendQueryParams({
        path: "https://move".concat(environmentSubdomain, ".").concat(domain, "/").concat(path),
        queryParams: queryParams || {},
    });
};
export var getMyTenantProfileUrl = function (params) {
    var _a = params.path, path = _a === void 0 ? "" : _a, queryParams = params.queryParams;
    // TODO: Pre-release AWS account on custom domain
    var localizedDomain = "mytenantprofile";
    switch (getLocale()) {
        case ELocale.NL:
            localizedDomain = "mijnhuurprofiel";
        case ELocale.FR:
            localizedDomain = "monprofillocataire";
        case ELocale.EN:
        default:
            break;
    }
    var domain = "".concat(localizedDomain, ".be");
    switch (CONFIG.ENVIRONMENT) {
        case EEnvironment.Dev:
        case EEnvironment.Stag:
        case EEnvironment.Demo:
            domain = "".concat(localizedDomain, "-internal.be");
            break;
        case EEnvironment.Prod:
        default:
            break;
    }
    var environmentSubdomain = "";
    switch (CONFIG.ENVIRONMENT) {
        case EEnvironment.Dev:
            environmentSubdomain = "dev.";
            break;
        case EEnvironment.Stag:
            environmentSubdomain = "stag.";
            break;
        case EEnvironment.Demo:
            environmentSubdomain = "demo.";
            break;
        case EEnvironment.Prod:
        default:
            break;
    }
    return appendQueryParams({
        path: "https://".concat(environmentSubdomain).concat(domain, "/").concat(path),
        queryParams: queryParams || {},
    });
};
export var getRentioMoveUrl = function (contractId, movement) {
    var path = "dashboard/".concat(movement.toLowerCase(), "/").concat(contractId);
    switch (CONFIG.ENVIRONMENT) {
        case EEnvironment.Dev:
        case EEnvironment.Stag:
        case EEnvironment.Demo:
            return "https://move.stag.rentio-internal.be/".concat(path);
        case EEnvironment.Prod:
        default:
            return "https://rentiomove.be/".concat(path);
    }
};
